import script from "./ReviewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewPage.vue?vue&type=style&index=0&id=b3d471cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d471cc"]])

export default __exports__